var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"th-step",class:{
    'th-step--done': _vm.done,
    'th-step--failed': _vm.failed,
    'th-step--sm': _vm.sm,
  }},[(_vm.failed)?_c('span',[_c('v-icon',[_vm._v("mdi-close")])],1):(_vm.done)?_c('span',[_c('v-icon',[_vm._v("mdi-check")])],1):_c('span',[_vm._t("step")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }